import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=0716a29d&scoped=true&"
import script from "./QuestionDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=0716a29d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716a29d",
  null
  
)

export default component.exports